export const sessionKeys = {
  session: ["session"],
  authOptions: ["auth-options"],
} as const;

export const accessKeys = {
  all: ["access"],
  members: ["access", "members"],
  domains: ["access", "domains"],
  credentials: ["access", "credentials"],
} as const;

export const auditKeys = {
  all: ["audit"],
  list: (params: unknown) => ["audit", params] as const,
  profile: (id: string) => ["audit", "profile", id] as const,
} as const;

export const AFTER_ACCESS_CHANGE = [accessKeys.all, auditKeys.all, sessionKeys.session] as const;
